<div class="container-fluid">
    <div>
        <app-outward-approver-header (searchByName)="searchOfficeByName($event)" [tableSettings]="tableSetting.columns"></app-outward-approver-header>
    </div>
    <div class="mt-1">
  <table class="table">
      <thead>
          <tr >
              <td class="w-8" *ngFor="let column of tableSetting.columns;let i = index">
                    <div *ngIf="column.isSortable">
                      
                        <span class="columheader" style="cursor:pointer">{{column.title}}</span>                   
                        <span class="icon-ic_filtered column-filter-icon cursor-pointer"  (click)="showSortingPopup(column)" *ngIf="column.isFilterIcon"></span>
                        
                    </div>
                    <div  *ngIf="!column.isSortable">
                        <span class="columheader">{{column.title}}</span>
                    </div>
                    <div class="resource-dropdown" *ngIf="column.displaysort">
                        <app-outward-filter [registrationArray] = "registrationArray" [statusArray] = "statusArray"
                        [column]="column" [tableSettings]="tableSetting" 
                        (gridFiltersApplied)="checkFilterApplied($event)"></app-outward-filter>   
                    </div>
              </td>
          </tr>
      </thead>
      <tbody class="results-list-panel">          
                <div class="no-search-results"  *ngIf="((usersList!=null)&&(usersList.length==0))">
                    <img src="../../../../assets/images/No results.png" width="240px" height="200px"/>
                    <label style="color:black;line-height: 24px;font-weight: 600;">No registration to display</label>
                    <label>No registrations have been added to this<br/> list. To add new registration click the button<br/> below</label>
                    <br/>
                    <button routerLink="/AddOutward" routerLinkActive="active" class="button" type="button" style="border: 1px solid #007CB0;background-color: #fff;color: #007CB0;">New Registration</button>
                </div>
                <tr *ngFor="let consent of usersList | paginate: { itemsPerPage: 10, currentPage: p, totalItems: totalCount};let i = index" tooltip="Click to View Details">

          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" >{{consent.serialNumber ? consent.serialNumber  : '-'}}</span>
          </td>
          <!-- <td class="tablewidth">
            <span class="showellipsis" >{{consent.gatepassNumber ? consent.gatepassNumber  : '-'}}</span>
          </td> -->
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" style="width:107px;" tooltip="{{consent.requestName}}">{{consent.requestName ? consent.requestName  : '-'}}</span>
          </td>
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" >{{consent.requestTypeName ? consent.requestTypeName  : '-'}}</span>
          </td>
         
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <div [ngClass]="{'bg-created':consent.status==='Created','bg-received':consent.status==='Received','bg-superApproved':consent.status==='Supervisor Approved','bg-appr1':consent.status==='LA approved 1','bg-appr2':consent.status==='LA approved 2','bg-printPass':consent.status==='Print pass','bg-cancelled':consent.status==='Cancelled','bg-declined':consent.status==='Declined'}">
              <span class="showellipsis"   >{{consent.status ? consent.status  : '-'}}</span></div>
            <!-- <span class="showellipsis"  [ngClass]="{'bg-created':consent.status==='Created','bg-received':consent.status==='Received','bg-superApproved':consent.status==='Supervisor approval','bg-appr1':consent.status==='LA approval 1','bg-appr2':consent.status==='LA approval 2','bg-printPass':consent.status==='Print pass','bg-cancelled':consent.status==='Cancelled'}" >{{consent.status ? consent.status  : '-'}}</span> -->
          </td>
         
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" >{{consent.requestDateTime ? (consent.requestDateTime  | date:'d/MMM/y, h:mm a') : '-'}}</span>
          </td>
          <!-- <td class="text-truncate" >
            <span class="showellipsis"  *ngIf="consent.requestTypeName == 'Returnable'">{{consent.returnDateTime | date:'MMM/d/y, h:mm a'}}</span>
            <span style="display: flex;justify-content: center;" class="showellipsis" *ngIf="consent.requestTypeName != 'Returnable'">-</span>                
        </td> -->
        <td class="text-truncate" (click)="detailedIOnfo(consent.requestId)" *ngIf="!(duedatecomparer>consent.revisedDate) && (consent.status!='Received' || consent.status!='Cancelled')">
          <span class="showellipsis"  *ngIf="consent.requestTypeName != 'Non-Returnable'"  [ngStyle]="{'color': consent.duedatebeforetwodays ? '#FFBF00' : 'black'}">{{consent.revisedDate | date:'d/MMM/y, h:mm a'}}</span>
          <span style="display: flex;justify-content: center;" class="showellipsis" *ngIf="consent.requestTypeName == 'Non-Returnable'">-</span>                
          
          
      </td>
      <td class="text-truncate" (click)="detailedIOnfo(consent.requestId)" *ngIf="(consent.requestTypeName == 'Non-Returnable' && (consent.status=='Received' || consent.status=='Cancelled'))">
        <span style="display: flex;justify-content: center;" class="showellipsis">-</span>                
      </td>
   
      <td class="text-truncate" (click)="detailedIOnfo(consent.requestId)" *ngIf="duedatecomparer>consent.revisedDate && (consent.status!='Received' && consent.status!='Cancelled')">
        <span class="showellipsis"  *ngIf="consent.requestTypeName != 'Non-Returnable'" style="color: red;">{{consent.revisedDate | date:'d/MMM/y, h:mm a'}}  
           <img src="../../../../assets/images/OIP.jpg" style="width:14px">
        </span>
        <span style="display: flex;justify-content: center;" class="showellipsis" *ngIf="consent.requestTypeName == 'Non-Returnable'">-</span>                
    </td>

        <!--CHANGE for RequestedBy with the variable -->
        <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
          <span class="showellipsis" >{{consent.lastName ? consent.lastName  : '-'}}, {{consent.firstName ? consent.firstName  : '-'}}</span>  
        </td>
      
<td *ngIf="consent.status==='Created'">
  <span style="padding-top: 5px;float: right; 
          padding-right: 18px; cursor: pointer;" (click)="onAccept(consent.status,consent.requestId,consent.serialNumber)" tooltip="Approve">&#10004;</span>
</td>       
<td *ngIf="consent.status==='Created'">
  <div class="Deletebtn">
    <div class="BoxOne">
      <span style="padding-top: 5px;float: right; 
          padding-right: 18px; cursor: pointer;" (click)="onReject(consent)" tooltip="Reject">&#10006;</span>
    </div>
  </div>
</td> 
<td *ngIf="(consent.status==='Received' || consent.status==='Declined' || consent.status==='Cancelled')"></td>
<td *ngIf="(consent.status==='Received' || consent.status==='Declined' || consent.status==='Cancelled')"></td>
        </tr>
          </tbody>
      </table>
    </div>
    <div class="paginationwithcount" *ngIf="((usersList!=null)&&(usersList.length>0))" (click)="hideDropdowns()">
        <span class="mb-4 mx-4">Page</span>
        <pagination 
                    [(ngModel)]="filterData.page"
                    [boundaryLinks]="true" 
                    (pageChanged)="changeCurrentPage($event);p = $event"
                    [(totalItems)] = "totalCount"
                    [maxSize]="5"
                    firstText="&shy;"
                    lastText="&shy;"
                    previousText="&shy;"
                    nextText="&shy;"
                    [rotate]="false"
                    [itemsPerPage] = "itemsperPage"
                    >
        </pagination>  
    </div>
    <div class="totalcount" *ngIf="((usersList!=null)&&(usersList.length>0))"><span>{{((filterData.page -1) * itemsperPage )+ 1}} - {{ countLength }} of <b>{{totalCount}}</b></span></div>
</div>
